<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>การจัดส่งสินค้า</strong></v-card-title>
          </v-layout>
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสร้านค้า</strong></p>
                <v-text-field v-model="username_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :item-text="searchitem.itemtext"
                      :item-value="searchitem.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="orderfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-5>
                  <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่สั่งซื้อ</strong></p>
                  <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="dateorderpicker" only-date range v-on:input="daterangefunction(dateorderpicker, 'order')">
                    <v-text-field v-model="dateorderview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                  </VueCtkDateTimePicker>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-5>
                  <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่จัดส่ง</strong></p>
                  <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="datedeliverypicker" only-date range v-on:input="daterangefunction(datedeliverypicker, 'delivery')">
                    <v-text-field v-model="datedeliveryview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                  </VueCtkDateTimePicker>
                </v-flex>
              </v-layout>

          <br />
          <div>
          <v-data-table
            :headers="headers"
            :items="orderdata_view"
            :items-per-page="10"
            show-select
            v-model="selected"
            class="elevation-3"
            item-key="_id"
            :loading="loading"
            @click="openorderdetail(item._id, 4)"
            :server-items-length="datalength"
            @update:page="pagechange"
            @update:items-per-page="itempagechange"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:item.order_no="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.order_no }}</div>
          </template>
          <template v-slot:item.username="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.username }}</div>
          </template>
          <template v-slot:item.adminref_name="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.adminref_name }}</div>
          </template>
          <template v-slot:item.name="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.name }}</div>
          </template>
          <template v-slot:item.order_date_th="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.order_date_th }}</div>
          </template>
          <template v-slot:item.tel="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.tel }}</div>
          </template>
          <template v-slot:item.delivery_date_th="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.delivery_date_th }}</div>
          </template>
          <template v-slot:item.order_status_th="{ item }">
            <v-chip
                :color="getColor(item.order_status)"
                text-color="white"
                @click="openorderdetail(item._id, 4)"
                style="cursor: pointer;"
              >{{ item.order_status_th }}
              </v-chip>
          </template>
          <template v-slot:item.payment_status_th="{ item }">
            <div style="cursor: pointer;" @click="openorderdetail(item._id, 4)">{{ item.payment_status_th }}</div>
          </template>
          </v-data-table>
          <br />
          <v-layout justify-end>
            <v-btn color="pink lighten-2" dark @click="delivered()">จัดส่ง</v-btn>
          </v-layout>
          </div>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
      <Orderdetailmodal :parentgetdata="getdata" />
    </v-layout>
  </v-container>
</template>

<script>
import Orderdetailmodal from '@/components/Orderdetailmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import swal from 'sweetalert'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Orderdetailmodal
  },
  data: () => ({
    isclerk: false,
    headers: [
      { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'เจ้าหน้าที่ผู้ดูแล', align: 'center', sortable: false, value: 'adminref_name' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'วันที่สั่ง', align: 'center', sortable: false, value: 'order_date_th' },
      { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
      { text: 'วันที่จัดส่ง', align: 'center', sortable: false, value: 'delivery_date_th' },
      { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status_th' },
      { text: 'การชำระเงิน', align: 'center', sortable: false, value: 'payment_status_th' }
    ],
    orderdatas: [],
    orderdata_view: [],
    csvheader: ['วันที่เอกสาร', 'เลขที่เอกสาร', 'วันที่ใบกำกับภาษี', 'เลขที่ใบกำกับภาษี', 'รหัสลูกหนี้/เจ้าหนี้', 'รหัสซื้อขาย', 'จำนวนสินค้า', 'จำนวนแถม', 'ราคาต่อหน่วย', 'ส่วนลดต่อรายการ', 'ตน.เก็บ', 'ตน.เก็บโอนย้าย', 'ส่วนลดท้ายบิล', 'หมายเหตุท้ายบิล'],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref_name', model: [] },
      { text: 'สถานะ', items: [], itemtext: 'order_status_th', model: [] },
      { text: 'การชำระเงิน', items: [], itemtext: 'payment_status_th', model: [] }
    ],
    selected: [],
    loading: false,
    dateorderpicker: '',
    dateorderview: '',
    datedeliverypicker: '',
    datedeliveryview: '',
    page: 1,
    itempage: 10,
    datalength: 0
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      this.isclerk = this.$cookies.get('status') === 'clerk' || false
      this.getsalename()
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async pagechange (p) {
      this.page = p
      await this.getdata()
    },
    async itempagechange (itp) {
      this.itempage = itp
      await this.getdata()
    },
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
      else if (status === '10') return '#52B9EB'
      else if (status === '11') return '#F7BA38'
      else if (status === '12') return '#388E3C'
      else if (status === '13') return '#F23B22'
      else if (status === '0') return 'info'
      else if (status === '1') return 'warning'
      else if (status === '2') return 'success'
      else if (status === '3') return '#DD4B39'
      else if (status === '4') return '#000000'
    },
    async getsalename () {
      this.loading = true
      let { data } = await axios.get(`${process.env.VUE_APP_API}/user/getinfo/salename`, {
        headers: {
          Authorization: this.$cookies.get('token')
        }
      })
      this.searchitems[0].items = data
      await this.getdata()
    },
    async getdata () {
      try {
        this.loading = true
        let salename = this.searchitems[0].model.length !== 0 ? this.searchitems[0].model : this.searchitems[0].items
        let { data } = await axios.post(`${process.env.VUE_APP_API}/order/get/all`, {
          orderstatus: ['10', '11'],
          paymentstatus: ['0', '1', '4'],
          orderno: this.orderno_search || '',
          customername: this.name_search || '',
          username: this.username_search || '',
          salename: salename,
          orderdate: this.dateorderview,
          deliverydate: this.datedeliveryview
        }, {
          headers: {
            Authorization: this.$cookies.get('token'),
            limit: this.itempage,
            skip: (Number(this.page) - 1) * Number(this.itempage)
          }
        })
        this.orderdatas = data.orderdata.filter(pd => pd.order_status === '10' || pd.order_status === '11').map((pd, index) => {
          return {
            ...pd,
            No: index + 1,
            order_date_th: moment(pd.order_date).format('ll'),
            delivery_date_th: pd.delivery_date ? moment(pd.delivery_date).format('ll') : ''
          }
        })
        this.orderdata_view = this.orderdatas
        for (const searchitem of this.searchitems) {
          searchitem.items = searchitem.items.length === 0 ? this.orderdatas : searchitem.items
        }
        this.datalength = Number(data.orderlength)
        this.loading = false
        // this.orderfilterfunction()
      } catch (error) {
        this.loading = false
      }
    },
    openorderdetail (id, mode) {
      this.orderdetailmodal = true
      this.currentorderid = id || ''
      this.orderdetailmode = mode === 1 ? 1 : 4
    },
    async orderfilterfunction () {
      this.page = 1
      await this.getdata()
      // this.orderdata_view = this.orderdatas.filter(order => {
      //   let condition = [
      //     this.name_search ? (order.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true,
      //     this.username_search ? (order.username.toLowerCase()).includes((this.username_search).toLowerCase()) : true,
      //     this.searchitems[0].model.includes(order.adminref_name) || !this.searchitems[0].model.length,
      //     this.searchitems[1].model.includes(order.order_status_th) || !this.searchitems[1].model.length,
      //     this.searchitems[2].model.includes(order.payment_status_th) || !this.searchitems[2].model.length,
      //     this.dateorderview ? order.order_date.split('T')[0] >= this.dateorderview.split(' ~ ')[0] && order.order_date.split('T')[0] <= this.dateorderview.split(' ~ ')[1] : true,
      //     this.datedeliveryview ? order.delivery_date.split('T')[0] >= this.datedeliveryview.split(' ~ ')[0] && order.delivery_date.split('T')[0] <= this.datedeliveryview.split(' ~ ')[1] : true
      //   ]
      //   return condition.every(con => con)
      // })
    },
    async delivered (id) {
      try {
        if (this.selected.length !== 0) {
          let deliveredlist = this.selected
          let swaltext = deliveredlist.length === 1 ? `ยืนยันการจัดส่งรายการสั่งซื้อ เลขที่: ${deliveredlist[0].order_no} ?` : `ยืนยันการจัดส่งรายการสั่งซื้อทั้งหมด ${deliveredlist.length} รายการ ?`
          await swal({
            title: swaltext,
            icon: 'warning',
            buttons: ['ยกเลิก', 'ยืนยัน'],
            dangerMode: true
          }).then(async (willdelivery) => {
            if (willdelivery) {
              await axios.post(`${process.env.VUE_APP_API}/order/edit/delivered`, {
                deliveredlist: deliveredlist.map(select => { return { _id: select._id } }),
                delivered_status: true
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
              let swaltextsuccess = deliveredlist.length === 1 ? `จัดส่งรายการสั่งซื้อ เลขที่: ${deliveredlist[0].order_no} เรียบร้อย` : `จัดส่งรายการสั่งซื้อทั้งหมด ${deliveredlist.length} รายการเรียบร้อย`
              await swal(swaltextsuccess, {
                icon: 'success',
                buttons: 'ตกลง'
              })
              this.getdata()
            }
          })
        } else {
          swal({
            title: `กรุณาเลือกรายการที่จัดส่ง`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    daterangefunction (datepicker, mode) {
      if (mode === 'order') {
        this.dateorderview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      } else if (mode === 'delivery') {
        this.datedeliveryview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      }
      this.orderfilterfunction()
    }
  },
  computed: {
    orderdetailmodal: sync('orderdetailmodal'),
    currentorderid: sync('currentorderid'),
    orderdetailmode: sync('orderdetailmode'),
    currentorderproduct: sync('currentorderproduct')
  }
}
</script>

<style scoped>
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}

.v-data-table {
  font-family: 'Kanit';
}
td {
  max-width: 120px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.date-time-picker * {
  font-family: 'Kanit' !important;
}
</style>
